export const GET_USER = {
  REQUEST: 'REQUEST_GET_USER',
  RECEIVE: 'RECEIVE_GET_USER',
  FAILURE: 'FAILURE_GET_USER',
};

export const GET_PROPERTY_DETAILS = {
  REQUEST: 'REQUEST_GET_PROPERTY_DETAILS',
  RECEIVE: 'RECEIVE_GET_PROPERTY_DETAILS',
  FAILURE: 'FAILURE_GET_PROPERTY_DETAILS',
};

export const GET_APPLICATION_PERMISSIONS = {
  REQUEST: 'REQUEST_GET_APPLICATION_PERMISSIONS',
  RECEIVE: 'RECEIVE_GET_APPLICATION_PERMISSIONS',
  FAILURE: 'FAILURE_GET_APPLICATION_PERMISSIONS',
};

export const GET_GOOGLE_MAPS_SIGNED_URL = {
  REQUEST: 'REQUEST_GET_GOOGLE_MAPS_SIGNED_URL',
  RECEIVE: 'RECEIVE_GET_GOOGLE_MAPS_SIGNED_URL',
  FAILURE: 'FAILURE_GET_GOOGLE_MAPS_SIGNED_URL',
};

export const SEND_APPLICATION_INVITATION = {
  REQUEST: 'REQUEST_SEND_APPLICATION_INVITATION',
  RECEIVE: 'RECEIVE_SEND_APPLICATION_INVITATION',
  FAILURE: 'FAILURE_SEND_APPLICATION_INVITATION',
};
